import React from 'react';
import PropTypes from 'prop-types';
import PageSection from '../PageSection';
import { Grid, Typography } from '@mui/material';

const TextSection = ({ title, children }) => {
  return (
    <PageSection maxWidth={'md'} spacing={'slim'}>
      <Grid container>
        <Grid item xs={12} sm={9}>
          <Typography variant={'h3'}>{title}</Typography>
          <Typography variant={'subtitle1'}>{children}</Typography>
        </Grid>
      </Grid>
    </PageSection>
  );
};

TextSection.propTypes = {
  title: PropTypes.string.isRequired,
};

TextSection.defaultProps = {};

export default TextSection;
